// export const BaseIp = "http://192.168.29.104:8088/"; // Local Server

export const BaseIp = "https://digitaltkiet.in/"; // Web Server

export const ProIp = BaseIp + "digital-library/";  // Local Server with AppName /digital-library/userLoginAPI